import React from 'react'
import PrivacySecurity from './PrivacySecurity'
import PrivacySecurityText from './PrivacySecurityText'
const PrivacySecuritypage = () => {
  return (
      <>
          <PrivacySecurity />
          <PrivacySecurityText/>
      </>
  )
}

export default PrivacySecuritypage